// utils/uuid_token.js
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

export const getUUID = () => {
    // 从本地存储中获取 UUID
    let uuid_token = localStorage.getItem('UUIDTOKEN');
    // 如果本地存储中没有 UUID，则生成一个新的 UUID 并保存到本地存储
    if (!uuid_token) {
        uuid_token = uuidv4();
        localStorage.setItem('UUIDTOKEN', uuid_token);
    }
    return uuid_token;
};

// 用「裸 axios」注册访客会话拿到 uuidtoken：
// 故意不走带拦截器的 request2/request，避免①循环依赖（request → api/user → request）
// ②访客 token 失效时 1001 拦截器里又调它造成递归。
// 后端 /user/visitorRegister 返回信封 { code, data:{ token }, msg }。
export const registerVisitor = async () => {
    const uuid = getUUID();
    const { data } = await axios.post(
        `${process.env.VUE_APP_API}/user/visitorRegister?userName=${uuid}`
    );
    const token = data && data.data && data.data.token;
    if (token) localStorage.setItem('uuidtoken', token);
    return token || '';
};

// 确保存在可用的访客会话：已存在直接复用（无网络开销），否则注册一个。
// 任何阶段（main.js 挂载前、App.created、1001 兜底）都可安全重复调用。
export const ensureVisitor = async () => {
    const existing = localStorage.getItem('uuidtoken');
    if (existing) return existing;
    try {
        return await registerVisitor();
    } catch (e) {
        console.error('visitor register failed', e);
        return '';
    }
};
